module.exports = __webpack_public_path__ + "static/media/ic_hs_insured.a287d170.svg";